import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import HomePage from "@/pages/HomePage";
import BookingPage from "@/pages/BookingPage";
import ConfirmationPage from "@/pages/ConfirmationPage";
import CancelPage from "@/pages/CancelPage";
import LegalPage from "@/pages/LegalPage";
import PrivacyPage from "@/pages/PrivacyPage";
import TermsPage from "@/pages/TermsPage";
import AdminLogin from "@/pages/admin/AdminLogin";
import AdminLayout from "@/pages/admin/AdminLayout";
import AdminDashboard from "@/pages/admin/AdminDashboard";
import AdminServicios from "@/pages/admin/AdminServicios";
import AdminPeluqueros from "@/pages/admin/AdminPeluqueros";
import AdminClientes from "@/pages/admin/AdminClientes";
import AdminConfiguracion from "@/pages/admin/AdminConfiguracion";

function App() {
  return (
    <div className="App min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          {/* Public Routes */}
          <Route path="/" element={<HomePage />} />
          <Route path="/reservar" element={<BookingPage />} />
          <Route path="/confirmacion/:citaId" element={<ConfirmationPage />} />
          <Route path="/cancelar" element={<CancelPage />} />
          <Route path="/aviso-legal" element={<LegalPage />} />
          <Route path="/privacidad" element={<PrivacyPage />} />
          <Route path="/condiciones" element={<TermsPage />} />
          
          {/* Admin Routes */}
          <Route path="/admin/login" element={<AdminLogin />} />
          <Route path="/admin" element={<AdminLayout />}>
            <Route index element={<AdminDashboard />} />
            <Route path="servicios" element={<AdminServicios />} />
            <Route path="peluqueros" element={<AdminPeluqueros />} />
            <Route path="clientes" element={<AdminClientes />} />
            <Route path="configuracion" element={<AdminConfiguracion />} />
          </Route>
        </Routes>
        <Toaster position="top-center" richColors />
      </BrowserRouter>
    </div>
  );
}

export default App;
